import React from 'react';

export const EditorContext = React.createContext({});
